<template>
  <el-dialog
    :visible.sync="state"
    :append-to-body="true"
    custom-class="select-dialog__dialog">
    {{ message }}
    <div class="select-dialog__dialog-action">
      <button class="select-dialog__button select-dialog__button--primary" @click="dataReset()">リセットする</button>
      <button class="select-dialog__button select-dialog__button--cancel" @click="state = false">キャンセル</button>
    </div>
  </el-dialog>
</template>



<script>
import {
  Dialog,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/dialog.css'

export default {
  components: {
    'el-dialog': Dialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    message: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    dataReset() {
      let query = Object.assign({}, this.$route.query)

      for (let key in query) {
        if(key.indexOf('order_') === 0){
          let num = key.split('_')
          num = Number(num[1].replace('-', '.'))
          if (num > 3) {
            delete query[key]
            this.$store.commit('canvas/stagesReset')
            this.$store.commit('cart/stagesReset')
          }
        }
      }

      this.$router.replace({
        path: this.$router.path,
        query: query,
      })

      this.state = false
      this.$emit('success')
    },
  }
}
</script>



<style lang="scss">
.select-dialog {
  &__dialog {
    border-radius: 8px;
    text-align: center;
    width: 90%;
    @include breakpoints-min(sm) {
      width: 80%;
    }
    @include breakpoints-min(md) {
      width: 65%;
    }
    @include breakpoints-min(lg) {
      width: 512px;
    }
  }
  &__dialog-action {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  &__button {
    $e: &;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: inline-block;
    appearance: none;
    transition: $transition;
    outline: none;
    border: none;
    background: transparent;
    font-size: 12px;
    text-align: center;
    color: $oc-gray-8;
    &:disabled {
      cursor: no-drop;
    }
    &--primary,
    &--cancel {
      border-radius: 999px;
      width: 176px;
      padding-top: 16px;
      padding-bottom: 16px;
    }
    &--primary {
      border: 1px solid $oc-gray-4;
      @include hover() {
        border-color: $accent-color;
        color: $accent-color;
      }
      @include active() {
        border-color: $accent-color;
        background-color: $accent-color-bg;
        color: $accent-color;
      }
    }
    &--cancel {
      border: 1px solid $accent-color;
      background-color: $accent-color;
      color: #fff;
      margin-left: 16px;
      @include hover() {
        border-color: $accent-color-hover;
        background-color: $accent-color-hover;
      }
      @include active() {
        border-color: $accent-color-active;
        background-color: $accent-color-active;
        color: #fff;
      }
    }
  }
}

.app-gogatsu  ~ .el-dialog__wrapper {
    .select-dialog {
        &__button {
            $e: &;
            color: $oc-gray-8;
            &--primary {
                border: 1px solid $oc-gray-4;
                @include hover() {
                    border-color: $gogatsu-accent-color;
                    color: $gogatsu-accent-color;
                }
                @include active() {
                    border-color: $gogatsu-accent-color;
                    background-color: $gogatsu-accent-color-bg;
                    color: $gogatsu-accent-color;
                }
            }
            &--cancel {
                border: 1px solid $gogatsu-accent-color;
                background-color: $gogatsu-accent-color;
                color: #fff;
                margin-left: 16px;
                @include hover() {
                    border-color: $gogatsu-accent-color-hover;
                    background-color: $gogatsu-accent-color-hover;
                }
                @include active() {
                    border-color: $gogatsu-accent-color-active;
                    background-color: $gogatsu-accent-color-active;
                    color: #fff;
                }
            }
        }
    }
}
</style>
